<template>
  <default-layout>
    <div class="container help--container">
      <banner :banner-text="bannerText" />
      <div class="help--wrapper">
        <div class="left--col">
          <page-select></page-select>
        </div>
        <div class="right--col" v-if="selectedHelp">
          <div class="help--content">
            <div class="content--text">
              <AccountRegistration
                v-if="selectedHelp.url.startsWith('account-registration')"
              ></AccountRegistration>
              <AccountPurchase
                v-else-if="selectedHelp.url.startsWith('account-purchase')"
              ></AccountPurchase>
              <Membership v-else-if="selectedHelp.url.startsWith('membership')"></Membership>
              <Upgrade v-else-if="selectedHelp.url.startsWith('upgrade')"></Upgrade>
              <Extend v-else-if="selectedHelp.url.startsWith('extend')"></Extend>
              <ListingSlot v-else-if="selectedHelp.url.startsWith('listing-slot')"></ListingSlot>
              <CoinUsage v-else-if="selectedHelp.url.startsWith('coin-usage')"></CoinUsage>
              <Coin v-else-if="selectedHelp.url.startsWith('coin')"></Coin>
              <Upload v-else-if="selectedHelp.url.startsWith('upload')"></Upload>
              <Repost v-else-if="selectedHelp.url.startsWith('repost')"></Repost>
              <Deactivate v-else-if="selectedHelp.url.startsWith('deactivate')"></Deactivate>
              <CatalogLink v-else-if="selectedHelp.url.startsWith('catalog-link')"></CatalogLink>
              <!--              <CoBroke v-else-if="selectedHelp.url.startsWith('co-broke')"></CoBroke>-->
              <EditProfile v-else-if="selectedHelp.url.startsWith('edit-profile')"></EditProfile>
              <ReferralCode v-else-if="selectedHelp.url.startsWith('referral-code')"></ReferralCode>
              <Password v-else-if="selectedHelp.url.startsWith('password')"></Password>
              <Inbox v-else-if="selectedHelp.url.startsWith('inbox')"></Inbox>
              <FeaturedAgent
                v-else-if="selectedHelp.url.startsWith('featured-agent')"
              ></FeaturedAgent>
              <TransferCoin v-else-if="selectedHelp.url.startsWith('transfer-coin')"></TransferCoin>
              <OwnerConnect v-else-if="selectedHelp.url.startsWith('owner-connect')"></OwnerConnect>
              <ProjectConnect
                v-else-if="selectedHelp.url.startsWith('project-connect')"
              ></ProjectConnect>
              <AgenNaikKelas
                v-else-if="selectedHelp.url.startsWith('agen-naik-kelas')"
              ></AgenNaikKelas>
              <RecommendedListing
                v-else-if="selectedHelp.url.startsWith('listing-rekomendasi')"
              ></RecommendedListing>
            </div>
          </div>
        </div>
      </div>
    </div>
  </default-layout>
</template>

<script>
import DefaultLayout from '@/layouts/default';
import Banner from '@/components/utils/page-banner';
import PageSelect from '@/components/utils/page-select';
import DefaultHeadMixin from '@/mixins/defaultHead';
import { mapState } from 'vuex';
import AccountRegistration from '@/components/static-page/help/account-registration.vue';
import AccountPurchase from '@/components/static-page/help/account-purchase.vue';
import Membership from '@/components/static-page/help/membership.vue';
import Upgrade from '@/components/static-page/help/upgrade.vue';
import Extend from '@/components/static-page/help/extend.vue';
import ListingSlot from '@/components/static-page/help/listing-slot.vue';
import Coin from '@/components/static-page/help/coin.vue';
import Upload from '@/components/static-page/help/upload.vue';
import Repost from '@/components/static-page/help/repost.vue';
import Deactivate from '@/components/static-page/help/deactivate.vue';
import CatalogLink from '@/components/static-page/help/catalog-link.vue';
// import CoBroke from '@/components/static-page/help/co-broke.vue';
import EditProfile from '@/components/static-page/help/edit-profile.vue';
import ReferralCode from '@/components/static-page/help/referral-code.vue';
import Password from '@/components/static-page/help/password.vue';
import CoinUsage from '@/components/static-page/help/coin-usage.vue';
import Inbox from '@/components/static-page/help/inbox.vue';
import FeaturedAgent from '@/components/static-page/help/featured-agent.vue';
import TransferCoin from '@/components/static-page/help/transfer-coin.vue';
import OwnerConnect from '@/components/static-page/help/owner-connect.vue';
import ProjectConnect from '@/components/static-page/help/project-connect.vue';
import AgenNaikKelas from '@/components/static-page/help/agen-naik-kelas.vue';
import RecommendedListing from '@/components/static-page/help/recommended-listing.vue';

export default {
  mixins: [DefaultHeadMixin],
  components: {
    OwnerConnect,
    ProjectConnect,
    AccountPurchase,
    AccountRegistration,
    Membership,
    Upgrade,
    Extend,
    ListingSlot,
    Coin,
    Upload,
    Repost,
    Deactivate,
    CatalogLink,
    // CoBroke,
    EditProfile,
    ReferralCode,
    Password,
    CoinUsage,
    Inbox,
    DefaultLayout,
    Banner,
    PageSelect,
    FeaturedAgent,
    TransferCoin,
    AgenNaikKelas,
    RecommendedListing,
  },
  computed: {
    ...mapState({
      selectedHelp: (state) => state.help.selectedHelp,
      helpList: (state) => state.help.helpList,
    }),
  },
  data: () => ({
    bannerText: 'FAQ.helpCenter',
  }),
  mounted() {
    if (this.$route.params.type) {
      const help = this.helpList.find((help) => {
        return help.url === this.$route.params.type;
      });
      this.$store.commit('help/SET_SELECTED_HELP', help);
    } else {
      this.$store.commit('help/SET_SELECTED_HELP', this.helpList[0]);
    }
  },
};
</script>
